import { Box, Button } from "@mui/material";
import React from "react";
import { buttonColors } from "../../utility/types/constant";

interface CircleDetailsProps {
  onClick: () => void;
}

const CircleDetails = (props: CircleDetailsProps) => {
  const { onClick } = props;
  return (
    <React.Fragment>
      <Box sx={{ p: 2 }}>
        <Button
          size="large"
          variant="contained"
          onClick={onClick}
          sx={{
            bgcolor: buttonColors.primary,
            "&:hover": {
              bgcolor: buttonColors.primary,
            },
          }}
        >
          More Details
        </Button>
      </Box>
    </React.Fragment>
  );
};

export default CircleDetails;
